import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {CookieService} from 'ngx-cookie-service';

import {SharedModule} from '../shared/shared.module';
import {AlreadyLoggedInGuard} from '../guards/already-logged-in.guard';
import {LoginComponent} from './login/login.component';
import {RegisterComponent} from './register/register.component';
import {WelcomeLayoutComponent} from './welcome-layout/welcome-layout.component';
import {AccountComponent} from './account.component';
import {LogoutComponent} from './logout/logout.component';
import {MyAccountComponent} from './my-account/my-account.component';
import {ChangeEmailComponent} from './my-account/change-email/change-email.component';
import {PersonalDetailsComponent} from './my-account/personal-details/personal-details.component';
import {SupportPinComponent} from './my-account/support-pin/support-pin.component';
import {ChangePasswordComponent} from './my-account/change-password/change-password.component';
import {SignRequestComponent} from './sign-request/sign-request.component';
import {CompanyProfileComponent} from './my-account/company-profile/company-profile.component';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {AuthorizedGpGuard} from '../guards/authorized-gp.guard';
import {ContactUnsubscribeComponent} from './contact-unsubscribe/contact-unsubscribe.component';
import {EmailConfirmComponent} from './email-confirm/email-confirm.component';
import {EmailSuspendComponent} from './email-suspend/email-suspend.component';
import {EmailVerificationComponent} from './email-verification/email-verification.component';
import {SocialLoginComponent} from './my-account/social-login/social-login.component';
import {TwoFactorAuthenticationComponent} from './my-account/two-factor-authentication/two-factor-authentication.component';
import {TwoFactorVerificationComponent} from './two-factor-verification/two-factor-verification.component';
import {MaintenanceGuard} from '../guards/maintenance.guard';
import {SubdomainGpGuard} from '../guards/subdomain-gp.guard';
import {AnonymousPageGuard} from '../guards/anonymous-page.guard';
import {CovercySharedComponentsModule} from '../shared/CovercySharedComponents.module';
import {MaterialModule} from '../shared/material.module';
import {NgxCaptchaModule} from 'ngx-captcha';
import {DataComponent} from './my-account/data/data.component';
import {GpSharedModule} from '../shared/gp-shared.module';
import {ManageUsersComponent} from './manage-users/manage-users.component';
import {UserAndPermissionTableComponent} from './manage-users/user-and-permission-table/user-and-permission-table.component';
import {UserAndPermissionEditDialogComponent} from './manage-users/user-and-permission-edit-dialog/user-and-permission-edit-dialog.component';
import {SectionsPipe} from './manage-users/user-and-permission-table/sections.pipe';
import {PermissionGuard} from '../guards/permission-guard.service';
import PermissionLevel from '../permission/enums/permissionLevel.enum';
import {VerifyEmailGuard} from '../guards/verify-email.guard';

@NgModule({
  declarations: [
    WelcomeLayoutComponent,
    AccountComponent,
    LoginComponent,
    RegisterComponent,
    LogoutComponent,

    MyAccountComponent,
    ChangeEmailComponent,
    ChangePasswordComponent,
    PersonalDetailsComponent,
    SupportPinComponent,
    SignRequestComponent,
    CompanyProfileComponent,

    ForgotPasswordComponent,
    ResetPasswordComponent,
    ContactUnsubscribeComponent,
    EmailConfirmComponent,
    EmailSuspendComponent,
    EmailVerificationComponent,
    SocialLoginComponent,
    TwoFactorAuthenticationComponent,
    TwoFactorVerificationComponent,
    DataComponent,
    UserAndPermissionEditDialogComponent,
    ManageUsersComponent,
    UserAndPermissionTableComponent,
    SectionsPipe
  ],
  exports: [
    ChangePasswordComponent,
    SupportPinComponent,
    ChangeEmailComponent,
    PersonalDetailsComponent,
    CompanyProfileComponent,
    SocialLoginComponent,
    TwoFactorAuthenticationComponent,
    WelcomeLayoutComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    CovercySharedComponentsModule,
    GpSharedModule,
    MaterialModule,
    RouterModule.forChild([
      {
        path: 'account',
        component: AccountComponent,
        canActivate: [MaintenanceGuard],
        children: [
          {
            path: 'me',
            component: MyAccountComponent,
            canActivate: [SubdomainGpGuard, VerifyEmailGuard, AuthorizedGpGuard]
          },
          {
            path: 'manage-users',
            component: ManageUsersComponent,
            canActivate: [SubdomainGpGuard, AuthorizedGpGuard, PermissionGuard],
            data: {minimumPermissionLevel: PermissionLevel.Admin}
          },
          {
            path: 'signup',
            component: RegisterComponent,
            canActivate: [SubdomainGpGuard, AnonymousPageGuard]
          },
          {
            path: 'login',
            component: LoginComponent,
            canActivate: [SubdomainGpGuard, AlreadyLoggedInGuard, AnonymousPageGuard]
          },
          {
            // *** TEMP - Old emails suppport - Remove after March. 2020 *** arriving here from email link
            path: 'sign-request/:investmentId/:uniqueIdentifier',
            component: SignRequestComponent,
            canActivate: [AnonymousPageGuard]
          },
          {
            // *** TEMP - Old emails suppport - Remove after March. 2020 *** This is only used by LPs, but we keep it here to support already sent emails links
            path: 'contact/:contactId/subscription/:uniqueIdentifier',
            component: ContactUnsubscribeComponent
          },

          {path: '**', redirectTo: 'login'}
        ]
      }
    ]),
    NgxCaptchaModule
  ],
  providers: [AuthorizedGpGuard, MaintenanceGuard, CookieService]
})
export class AccountModule {
}
